import { IMAGE_BASE_PATH } from "@/config/config";
import { Box } from "@mui/material";
import Image from "next/image";
import { func, number } from "prop-types";

export default function Logo({ handleLogoClick, width, height }) {
  return (
    <Box sx={{ cursor: "default", my: { xs: "0.3rem", md: 0 } }}>
      <Image
        alt="Tata AIG Logo"
        src={`${IMAGE_BASE_PATH}/bolt-new-logo.svg`}
        width={width}
        height={height}
        onClick={handleLogoClick}
        priority
      />
    </Box>
  );
}

Logo.propTypes = {
  handleLogoClick: func.isRequired,
  width: number,
  height: number,
};
